import React from 'react';
import { PropTypes } from 'prop-types';
import TextField from '../fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import './styles.scss';
import UniversalSearchField from './universalSearchField/UniversalSearchField';
import _ from '../../utils/ObjectUtils';
import IconButton from "../others/IconButton";
import SelectField from '../fields/selectField/SelectField';

import filterButton from "./../../img/filter-button.svg";
import filterButtonInverted from "./../../img/filter-selected-button.svg";

import addButton from "./../../img/add-button.svg";
import clearIcon from "./../../img/clear-icon.svg";
import DateTimeField from "../fields/dateTime/DateTimeField";
import UserHasPermission, { modulesActions } from '../../../roles/components/UserHasPermission';
import TimeField from "../fields/dateTime/TimeField";
import DateField from "../fields/dateTime/DateField";

class SearchForm extends React.Component {
    constructor() {
        super();
        this.state = {
            filterBoxExpanded: false
        }
    }

    toggleFilterBoxExpanded = () => {
        const { filterBoxExpanded } = this.state;
        this.setState({
            filterBoxExpanded: !filterBoxExpanded
        })
    };

    render() {
        const { filterBoxExpanded } = this.state;
        const {
            handleFieldChange,
            content,
            handleClear,
            handleSubmit,
            universalSearchField,
            handleUniversalSearchFieldChange,
            handleAddButtonClicked,
            hideAddButton,
            hideUniversalSearch,
            appModule,
        } = this.props;

        const searchFieldsNotEmpty = !_.isNilOrEmpty(universalSearchField) || !_.isNilOrEmpty(content.rows.filter(row =>
            !_.isNilOrEmpty(row.fields.filter(field => !_.isNilOrEmpty(field.value)))
        ));

        return <>
            <div className='pt-4 pb-1 px-4' style={{ display: 'flex', height: '4.2rem' }}>
                <div>
                    {
                        !hideUniversalSearch && <UniversalSearchField
                            value={universalSearchField}
                            handleFieldChange={value => handleUniversalSearchFieldChange(value)}
                            handleSubmitOnEnterKey={e => this.handleSubmitOnEnterKeyPressed(e.key)}
                            handleSubmit={handleSubmit}
                        />
                    }
                    <IconButton
                        alt="filter"
                        image={filterButton}
                        invertedImage={filterButtonInverted}
                        selected={filterBoxExpanded}
                        handleIconClick={e => this.toggleFilterBoxExpanded(e.target.value)}
                    />
                    <button
                        className={'ml-3 mr-2 btn submit-btn ' + (searchFieldsNotEmpty ? "active" : "")}
                        onClick={handleSubmit}
                    >
                        {I18n.t('forms.submit')}
                    </button>
                    <button
                        className={'btn mx-2 clear-btn ' + (searchFieldsNotEmpty ? "active" : "")}
                        onClick={handleClear}
                    >
                        {I18n.t('forms.clear')}
                    </button>
                </div>
                {!hideAddButton && (
                    <UserHasPermission
                        appModule={appModule}
                        action={modulesActions.CREATE}
                    >
                        <div style={{ marginLeft: 'auto', marginRight: 0, display: 'flex' }} >
                            <IconButton
                                alt="add"
                                image={addButton}
                                handleIconClick={handleAddButtonClicked}
                            />
                        </div>
                    </UserHasPermission>
                )}
            </div>
            <div style={filterBoxExpanded ? {} : { display: 'none' }}>
                <div className="search-form">
                    {this.generateRows(content.rows, handleFieldChange, this.handleSubmitOnEnterKeyPressed)}
                </div>
            </div>
            <div className="container search-fields-preview-container" style={filterBoxExpanded ? { display: 'none' } : {}}>
                {this.generateFilterList(content.rows, handleFieldChange)}
            </div>

        </>
    }

    handleSubmitOnEnterKeyPressed = (key) => {
        if (key === 'Enter') {
            this.props.handleSubmit();
        }
    };

    generateFilterList = (rows, handleFieldChange) => {
        return <div className="row search-field-preview-row">
            {
                rows.map((row, rowIndex) => {
                    return row.fields
                        .filter(field => !_.isNilOrEmpty(field.value))
                        .map((field, fieldIndex) => this.generateFilterPreview(field, rowIndex, fieldIndex, handleFieldChange))
                })
            }
        </div>
    };

    generateFilterPreview = (field, rowIndex, fieldIndex, handleFieldChange) => {
        return (
            <div key={rowIndex + '_' + fieldIndex} className="col-3 search-field-preview">
                <div className="field-description">
                    <span style={{ color: "#9b9b9b" }}>
                        {field.type === 'dropdown' && !_.isNil(field.isMulti) && !field.isMulti ?
                            field.label + ": " + field.data.find(dataEntry => field.value === dataEntry.value).label :
                            field.type === 'dropdown' ?
                                field.value.length > 1 ?
                                    field.label + ": " + I18n.t('searchForm.filterPreview.dropdown', { numberOfElements: field.value.length }) :
                                    field?.label + ": " + field?.data.find(dataEntry => field.value[0] === dataEntry.value)?.label :
                                field.label + ": " + field.value
                        }
                    </span>
                </div>
                <div className="field-clear">
                    <span className="clear" onClick={() => handleFieldChange(field.id, "")}>
                        <img src={clearIcon} alt="x" />
                    </span>
                </div>
            </div>
        )
    };

    generateRows = (rows, handleFieldChange, handleSubmitOnEnterKeyPressed) => {
        return <>
            {rows.map((row, index) => {
                return (
                    <div key={index} className="search-form-row pt-3">
                        {row.hasTopBreak ? <hr /> : null}
                        <div className="row" style={row.style} onKeyDown={e => handleSubmitOnEnterKeyPressed(e.key)}>
                            {row.fields.map((field, index) => this.generateField(field, index, handleFieldChange))}
                        </div>
                        {row.hasBottomBreak ? <hr /> : null}
                    </div>
                )
            })}
        </>
    };

    generateField = (field, index, handleFieldChange) => {
        const {
            id,
            value = "",
            data,
            label,
            isMulti = true,
            min = "",
            max = ""
        } = field;

        switch (field.type) {
            case "dropdown":
                return <div key={index} className="col-4" >
                    <SelectField
                        label={label}
                        value={value}
                        themeName="form"
                        options={data}
                        isMulti={isMulti}
                        handleFieldChange={value => handleFieldChange(id, value)}
                        width={12}
                    />
                </div>;
            case "dateTime":
                return <div key={index} className="col-4" >
                    <DateTimeField
                        label={label}
                        value={value}
                        themeName="form"
                        handleFieldChange={value => handleFieldChange(id, value)}
                        width={12}
                        
                    />
                </div>;
            case "time":
                return <div key={index} className="col-4" >
                    <TimeField
                        label={label}
                        value={value}
                        themeName="form"
                        handleFieldChange={value => handleFieldChange(id, value)}
                        width={12}
                    />
                </div>;
            case "date":
                return <div key={index} className="col-4" >
                    <DateField
                        label={label}
                        value={value}
                        themeName="form"
                        handleFieldChange={value => handleFieldChange(id, value)}
                        width={12}
                        min={min}
                        max = {max}
                        
                    />
                </div>;
            case "text":
            default:
                return <div key={index} className="col-4" >
                    <TextField
                        key={index}
                        value={value}
                        label={label}
                        handleFieldChange={value => handleFieldChange(id, value)}
                        themeName="form"
                        width={12}
                    />
                </div>;
        }
    };
}

SearchForm.propTypes = {
    content: PropTypes.object,
    universalSearchField: PropTypes.string,
    hideAddButton: PropTypes.bool,
    handleUniversalSearchFieldChange: PropTypes.func,
    handleFieldChange: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleClear: PropTypes.func.isRequired,
    handleAddButtonClicked: PropTypes.func,
    hideUniversalSearch: PropTypes.bool,
};

export default SearchForm;